import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { Column, GridApi, ICellRendererParams, IHeaderGroupParams, IHeaderParams, SortDirection } from 'ag-grid-community';

@Component({
    selector: 'app-custom-header',
    templateUrl: './custom-header.component.html',
    styleUrls: ['./custom-header.component.scss'],
    standalone: false // NOSONAR
})
export class CustomHeaderComponent implements IHeaderAngularComp {
 private params:any;
  headerName: any;
  sortable: boolean;
  unsortIcon: boolean;
  checkSort:string = null;
  constructor() { }
  refresh(_params: IHeaderParams<any, any>):boolean {
    return false;
  }
  

  agInit(params:any):void{
     this.params=params;
     console.info('Params..........',this.params);
     this.headerName = params.column.colDef.headerName;
  }
  expandAll(){
    this.params.api.forEachNode((node)=>{
      if(node.group){
        node.setExpanded(true);
      }
    });
  }
  collapseAll(){
    this.params.api.forEachNode((node)=>{
      if(node.group){
        node.setExpanded(false);
      }
    });
  }
  onSortRequested(event: any) {
    if(this.checkSort== null){
      this.checkSort='asc';
    }
    else if(this.checkSort == 'asc'){        // NOSONAR
      this.checkSort='desc';
    }
    else{
      this.checkSort= null;
    }
    this.params.setSort(this.checkSort, event.shiftKey);
}
}
